<script>
import GroupExpandRow from './GroupExpandRow'

const handlerCallBack = (context, props) => {
  const listener = context.listeners['handleGroupClick'] || (() => {})
  return listener(props)
};

export default {
  name: 'ShouldGroup',
  functional: true,
  props: ['items', 'itemKey'],
  render(h, context) {
    if (context.parent.rowGroup) {
      return [
        <GroupExpandRow
          columnLength={context.parent.columnLength}
          items={context.props.items}
          itemKey={context.props.itemKey}
          showGroupIcon={context.parent.showGroupIcon}
          groupIcon={context.parent.groupIcon}
          vOn:click={expand => (context.props.items.expand = !expand)}
          vOn:clickEdit={item => handlerCallBack(context, item)}
        />,
        context.props.items.data.map((record, index) => {
          if (context.props.items.expand) {
            return context.scopedSlots.group({
              record: record,
              index: `${context.props.itemKey}__${index}`
            })
          }
        })
      ]
    }

    return context.scopedSlots.group({
      record: context.props.items,
      index: context.props.itemKey
    })
  }
}
</script>
